import API from 'core/api'
import cookies from 'js-cookie'
import _ from 'underscore'
import CONSTANTS from 'app/constants'

export default {

	namespaced: true,

	modules: {},

	state: {},

	getters: {},

	mutations: {},

	actions: {

		check: function(context) {

			return new Promise(function(resolve, reject) {

				API.request('session/check').then(function(json) {

					context.commit('session/set', json, { root: true })
					context.commit('data/games/add', json.data.games, { root: true })
					context.commit('session/presets/set', json.presets, { root: true })
					context.commit('session/config/set', json.config, { root: true })
					context.commit('filter/config/reset', json.config, { root: true })

					resolve(json)

				}, function(json) {

					cookies.remove('token')

					reject(json)

				})

			})

		},

		login: function(context, params) {

			return new Promise(function(resolve, reject) {

				API.request('session/login', params).then(function(json) {

					if(process.env.VUE_APP_ENV === 'development') {

						cookies.set('token', json.token, {
							expires: 365
						})

					} else {

						cookies.set('token', json.token, {
							domain: (process.env.VUE_APP_TYPE === 'externaldomain') ? window.location.hostname : ".geekgroup.app",
							path: "/",
							expires: 365,
							secure: true,
							sameSite: "None"
						})

					}

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})

		},

		logout: function(context, params) {

			return new Promise(function(resolve, reject) {

				API.request('session/logout', params).then(function(json) {

					cookies.remove('token')

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})

		},

		synctype: function(context, params) {

			return new Promise(function(resolve, reject) {

				API.request('session/synctype', params).then(function(json) {

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})

		},

		sync: function(context, params) {

			return new Promise(function(resolve, reject) {

				function call(syncKey) {

					if(syncKey) params.syncKey = syncKey

					API.request('session/sync', params).then(function(json) {

						resolve(json)

					}, function(json) {

						if (json.error=== CONSTANTS.STATUS.ERROR.SYNC.INPROGRESS) {

							_.delay(function() { call(json.syncKey) }, 10000)

						} else {

							reject(json.error)

						}

					})

				}

				call()

			})

		}

	}

}